export default __webpack_public_path__ + "static/layer784-9d1d1b3b7af653299c80d33c36bc365a.jpg";